import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { VersionesService } from '../../services/versiones.service';
import { DireccionesUsuariosService } from '../../services/direcciones-usuarios.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';


@Component({
  selector: 'app-upload-csv-indicadores',
  templateUrl: './upload-csv-indicadores.component.html',
  styleUrls: ['./upload-csv-indicadores.component.css']
})

export class UploadCsvIndicadoresComponent implements OnInit {

  titulo = 'Carga de Presupuesto';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  loading2: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  cmbOpcionesV2: any[] = [
    { clave: true, valor: 'SI' },
    { clave: false, valor: 'NO' }
  ]

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  usuario: string;
  comboDireccion: any[];

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _catalogo: CatalogoIndicadoresService,
    private _indicadores: IndicadoresVivosService,
    private _versiones: VersionesService,
    private _direccionesUsuarios: DireccionesUsuariosService,
    private _dmaestrosServices : DatosMaestrosService,
  ) { }

  ngOnInit() {
    this.cmbOpciones = this._catalogo.catalogoOpciones();
    this.formulario = this.fb.group({
      version   : ['', []],
      opcion    : ['', [Validators.required]],
      multipart : ['', [Validators.required]],
      conversor : ['', [Validators.required]],
      tipo      : ['', [Validators.required]], //Tipo de Presupuesto
      canal     : ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGrid();

    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.getVersiones();

    this.formulario.get('conversor').valueChanges.subscribe((resp) => {
      this.getFormValidationErrors();
    });
      
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.usuario = userData.login2;
    
    this._direccionesUsuarios.getDireccionesUsuarios().subscribe((res: any[]) => {
      console.log("Direcciones del usuario actual", res);
      if(res) 
        this.comboDireccion = res.filter(e => e.codigoUsuario == this.usuario);
        res.map(e=> {e.nombreCanalVenta = e.codigoDireccion + " - " + e.nombreCanalVenta;  return e;});

    }, (err) => { this.comboDireccion = []; });

  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.isCorrect != undefined) {
      if (data.isCorrect === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.isCorrect === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Tipo de Presupuesto',
        sortable: true,
        filter: true,
        width: 200,
        valueGetter: function (params: any) {
          if (params.data.tipoPresupuesto == 1) return 'LE-COMERCIAL';
          if (params.data.tipoPresupuesto == 2) return 'LE-COMISIONES';
          else return '';
        }
      },
      {
        headerName: 'Año',
        field: this.modelGrid.anio,
        filter: true,
        width: 120,
        sortable: true
      },
      {
        headerName: 'Mes',
        field: this.modelGrid.mes,
        filter: true,
        width: 120,
        sortable: true
      },
      {
        headerName: 'Cod.Vendedor',
        field: this.modelGrid.codigoVendedor,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Nom.Vendedor',
        field: this.modelGrid.nombreVendedor,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Cod.Cliente',
        field: this.modelGrid.codigoCliente,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Nom.Cliente',
        field: this.modelGrid.nombreCliente,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Cod.Articulo',
        field: this.modelGrid.codigoArticulo,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Articulo',
        field: this.modelGrid.nombreArticulo,
        filter: true,
        width: 250,
        sortable: true
      },
      {
        headerName: ' ',
        field: 'factorConversion',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Cajas',
        field: this.modelGrid.cajas,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Kilos',
        field: this.modelGrid.kilos,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Dolares',
        field: this.modelGrid.dolares,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'MTV',
        field: this.modelGrid.mtv,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Venta Bruta',
        field: this.modelGrid.ventaBruta,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Sector',
        field: this.modelGrid.sector,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        field: 'usuario',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        field: 'tipo',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.isCorrect) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {
    const conversor = this.formulario.get('conversor').value;
    const tipo = this.formulario.get('tipo').value;
    const canal = this.formulario.get('canal').value;

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._indicadores.procesarCsvIndicadores(this.setFormData(this.formulario.value), conversor, tipo, canal),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    const opcion = this.formulario.get('opcion').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de Presupuesto?',
        text: '',
        action: 'Guardar',
        funcion: this._indicadores.saveCsvIndicadores(this.rowData, opcion),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
      this.downloadDataCsv();
    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['ANIO', 'MES', 'VENDEDOR', 'CLIENTE', 'PRODUCTO', 'CAJAS', 'KILOS', 'DOLARES', 'MTV', 'VENTABRUTA', 'SECTOR']];
    const data: any[] = [
      { 'anio': '2021', 'mes': 9, 'vendedor': '3113', 'cliente': '100012', 'articulo': '3031008/t02', 'cajas': 10, 'kilos': 10.5, 'dolares': 100, 'mtv': 100, 'ventaBruta': 100, 'sector': "00" }
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['ANIO', 'MES', 'VENDEDOR', 'NOM.VENDEDOR', 'CLIENTE', 'NOM.CLIENTE', 'PRODUCTO', 'CONTENEDOR', 'DES.PRODUCTO', 'CAJAS', 'KILOS', 'DOLARES', 'MTV', 'VENTA BRUTA', 'SECTOR', 'Estado', 'Linea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.isCorrect) {
        data.push(
          {
            anio: (e.anio === undefined) ? '' : e.anio,
            mesDescripcion: (e.mes === undefined) ? '' : e.mes,
            codigoVendedor: (e.codigoVendedor === undefined) ? '' : e.codigoVendedor,
            nombreVendedor: (e.nombreVendedor === undefined) ? '' : e.nombreVendedor,
            codigoCliente:  (e.codigoCliente === undefined) ? '' : e.codigoCliente,
            nombreCliente:  (e.nombreCliente === undefined) ? '' : e.nombreCliente,
            codigoArticulo: e.codigoArticulo,
            contenedor    : e.contenedor,
            nombreArticulo: (e.nombreArticulo === undefined) ? '' : e.nombreArticulo,
            cajas: (e.cajas === undefined) ? '' : e.cajas,
            kilos: (e.kilos === undefined) ? '' : e.kilos,
            dolares: (e.dolares === undefined) ? '' : e.dolares,
            mtv: (e.mtv === undefined) ? '' : e.mtv,
            ventaBruta: (e.ventaBruta === undefined) ? '' : e.ventaBruta,  
            sector: (e.sector === undefined) ? '' : e.sector,            
            estado: (e.isCorrect) ? 'CORRECTO' : 'INCORRECTO',
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  listaDeVersiones;

  getVersiones() {
    this.loading = true;
    this._versiones.getVersiones().subscribe((res: any) => {
      console.log("getVersionActiva()", res)
      this.loading = false;
      this.listaDeVersiones = res.filter(t => t.estado === 'A');

      for (let index = 0; index < this.listaDeVersiones.length; index++) {
        this.listaDeVersiones[index].versionNombre = this.listaDeVersiones[index].version + " - " + this.listaDeVersiones[index].nombre
      }

      this.formulario.get('opcion').setValue(this.listaDeVersiones.filter(t => t.estado === 'A')[0].id);
      this.formulario.get('opcion').disable();
    }, (err) => {
      this.loading = false;
      this.listaDeVersiones = '';
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

}
